module.exports = __webpack_public_path__ + "static/media/ces.3c25526e.png";